export default __webpack_public_path__ + "static/media/Initiate's Bands of the Moon.c8b0aeb6.jpg";